var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileUploadLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 105 105",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5655_44320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.625 17.5H21.875V87.5H83.125V35H65.625V17.5ZM13.125 13.09C13.125 10.6925 15.0806 8.75 17.4956 8.75H70L91.875 30.625V91.8444C91.879 92.4189 91.7699 92.9886 91.5537 93.521C91.3376 94.0533 91.0187 94.5379 90.6153 94.947C90.2119 95.3561 89.7318 95.6817 89.2026 95.9053C88.6733 96.1289 88.1052 96.246 87.5306 96.25H17.4694C16.3204 96.242 15.2207 95.7823 14.4078 94.9703C13.595 94.1582 13.1342 93.059 13.125 91.91V13.09ZM56.875 52.5V70H48.125V52.5H35L52.5 35L70 52.5H56.875Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5655_44320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 105,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadLine);
export default __webpack_public_path__ + "static/media/file-upload-line.1d847b091f31de686e1bde733ff48726.svg";
export { ForwardRef as ReactComponent };